/**
 * The member search in the top bar: type a name or an email, get the
 * people it matches with what Brian looks for first (status, plan, last
 * check, platform, help requests), and open the existing person page.
 * Reads GET /provider/admin/people?q= (the People list's own search, which
 * matches name, email and phone), team accounts included so Brian can find
 * his own.
 */
import { ago } from './format';
import { PLAN_LABEL, PLATFORM_LABEL, type PersonRow } from './people-data';

export const SEARCH_MIN_CHARS = 2;
export const SEARCH_LIMIT = 8;

export interface SearchFacts { status: string; plan: string; lastCheck: string; platform: string; help: string }

/** The five facts on a result line, each in words; nothing measured reads as the words, never 0. */
export const searchFacts = (p: PersonRow, now: number = Date.now()): SearchFacts => {
  const h = p.helpRequests;
  return {
    status: p.stageLabel || p.stage,
    plan: PLAN_LABEL[p.plan] ?? p.plan,
    lastCheck: p.lastCheckAt ? `last check ${ago(p.lastCheckAt, now)}` : 'never checked',
    platform: p.platforms.length ? p.platforms.map((x) => PLATFORM_LABEL[x] ?? x).join(', ') : 'platform not seen',
    help: !h ? 'help requests not reported' : h.total === 0 ? 'no help requests' : `${h.total} help ${h.total === 1 ? 'request' : 'requests'}${h.open ? `, ${h.open} open` : ''}`,
  };
};

/** Who the line is for: the name, else the email. */
export const searchTitle = (p: PersonRow): string => (p.name && p.name.trim() ? p.name.trim() : p.email);
